<template>
  <div>
    <el-radio-group v-model="isCollapse" style="margin-bottom: 20px"></el-radio-group>
    <el-menu default-active="1-4-1" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose"
      :collapse="isCollapse" background-color="#d80b0b00" text-color="#000000" active-text-color="#ffd04b">
      <!-- <el-menu-item index="0">
        <i class="el-icon-menu" color="#409EFC"></i>
        <template #title>收起</template>
      </el-menu-item>-->
      <el-menu-item index="1" @click="routerpath('/Car_manage')">
        <img src="../assets/img/menu_ssjk_hover.png" style="
            width: 23px;
            height: 23px;
            padding-right: 10px;
            padding-bottom: 5px;
          " />
        <template #title>多车模式</template>
      </el-menu-item>

      <el-menu-item index="4" @click="routerpath('/Bicycle_manage')">
        <i>
          <img src="../assets/img/menu_ghlj_hover.png" style="
              width: 25px;
              height: 25px;
              padding-right: 10px;
              padding-bottom: 5px;
            " />
        </i>
        <template #title>单车模式</template>
      </el-menu-item>
      <el-menu-item index="5" @click="routerpath('/Four_cars')">
        <i>
          <img src="../assets/img/menu_gjdt_hover.png " style="
              width: 20px;
              height: 20px;
              padding-right: 10px;
              padding-bottom: 5px;
            " />
        </i>
        <template #title>四车模式</template>
      </el-menu-item>

      <el-menu-item index="6" @click="dialogVisible = !dialogVisible">
        <i>
          <img src="../assets/img/menu_ycjg_hover.png " style="
              width: 20px;
              height: 20px;
              padding-right: 10px;
              padding-bottom: 5px;
            " />
        </i>
        <template #title>组织结构</template>
      </el-menu-item>
    </el-menu>
  </div>

  <el-dialog v-model="dialogVisible" title="系统提示" width="65%" :before-close="handleCl" @close="closeDialog">
    <div style="height: 500px;display: flex;justify-content: center">
      <div style="width: 30%;">
        <el-row>
          <el-col :span="18">
            <el-input v-model="filterText" placeholder="请输入" />
          </el-col>
          <el-col :span="2">

          </el-col>
          <el-col :span="4">
            <el-button type="primary" @click="g_car_group_list">搜索</el-button>
          </el-col>
        </el-row>
        <!-- <div style="margin-top: 1%;display: flex;">     <el-button type="primary" size="small" round> 添加根组织织</el-button></div> -->

        <!-- <el-input v-model="leftValue" placeholder="请输入" @change="g_car_group_list()" /> -->
        <div style="margin-top: 5%;">
          <el-tree ref="treeRef" :data="treedata" show-checkbox node-key="id" default-expand-all
            @node-click="handleBucketClick" :filter-node-method="filterNode" :expand-on-click-node="false">
            <template #default="{ node, data }">
              <div style="width: 100%;display: flex;justify-content: space-between; ">
                <div>{{ node.label }}</div>
                <div style="display: flex;width: 30%;justify-content: space-between;">
                  <CirclePlus color="green" style="width: 1em; height: 1em; margin-right: 8px" @click="addpar(node)" />
                  <edit color="blue" style="width: 1em; height: 1em; margin-right: 8px" @click="upid(node)" />
                  <delete color="red" style="width: 1em; height: 1em; margin-right: 8px" @click="delzuzhi(node)" />
                </div>
              </div>
            </template>
          </el-tree>
        </div>

      </div>
      <div style="width: 70%;">
        <div style=" margin:0  auto; width: 90%;">
          <el-transfer v-model="name" style="text-align: left; display: inline-block" filterable
            :render-content="renderFunc" :titles="['未选', '已选']" :button-texts="['移除', '加入']" :format="{
              noChecked: '${total}',
              hasChecked: '${checked}/${total}',
            }" :data="group" @change="handleChange">
            <template #left-footer>
              <!-- <el-button class="transfer-footer" size="small">Operation</el-button> -->
            </template>
            <template #right-footer>
              <!-- <el-button class="transfer-footer" size="small">Operation</el-button> -->
            </template>
          </el-transfer>
        </div>
      </div>
    </div>
  </el-dialog>

  <el-dialog v-model="add" title="系统提示" width="30%" :before-close="guanbi">
    <el-input v-model="addvalue" placeholder="请输入添加的组织名称" />
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="add = false">关闭</el-button>
        <el-button type="primary" @click="addzuzhi()">提交</el-button>
      </span>
    </template>
  </el-dialog>

  <el-dialog v-model="upd" title="系统提示" width="30%" :before-close="upguanbi">
    <el-input v-model="upvalue" placeholder="请输入更新的组织名称" />
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="upd = false">关闭</el-button>
        <el-button type="primary" @click="upzuzhi()">提交</el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script >
import { CirclePlus } from "@element-plus/icons";
import { Edit } from "@element-plus/icons";
import { Delete } from "@element-plus/icons";
import { ref, toRefs, reactive, watch } from "vue";
import { ElMessage, ElMessageBox } from 'element-plus'
import { get_area_list, get_car_group_list, delete_car_group, update_car_group, add_car_group, get_vin_list_by_group_id, add_car_to_group, delete_car_from_group } from "../api/car_manage/car_manage";
import { useRouter } from "vue-router";
// import { watch } from "fs";
export default {
  name: "ctar1",
  components: {
    CirclePlus,
    Edit,
    Delete,
  },
  setup(props, context) {
    const router = useRouter();
    const handleOpen = (key, keyPath) => {
    };
    const handleClose = (key, keyPath) => {
    };
    const data = reactive({
      isCollapse: true,
      car_list: "",
      car_info: "",
      display: false,
      search: "",
      dialogVisible: false,
      filterText: '',
      leftValue: '',
      treedata: [],
      name: [],
      gaibian: [],
      add: false,
      upd: false,
      upvalue: '',
      area_id: '',
      addvalue: '',
      zuzhiid: '',
      group: [],
      group_id: '',
      par_id: ''
    });
    const handleCl = (key) => {
    }
    const guanbi = () => {

    }
    const upguanbi = () => {

    }
    const filterText = ref('')
    const treeRef = ref('')
    const defaultProps = {
      children: 'children',
      label: 'label',
    }
    watch(filterText, (val) => {
      treeRef.value.filter(val)
    })
    const filterNode = (value, data) => {
      if (!value) return true
      return data.label.includes(value)
    }
    const addpar = (e) => {
      data.add = true
      data.par_id = e.data.value
    }
    const handleChange = (val, str) => {
      let list = ''
      let arr = []
      if (str == 'left') {
        list = getArrDifference(data.gaibian, val)
        for (let n in list) {
          arr.push(data.group[list[n]].label)
        }
        let str_vin = arr.join("--")
        delete_car_from_group(data.group_id, str_vin).then((res) => {
          g_vin_list_by_group_id(data.group_id)
        })
      }
      if (str == 'right') {
        list = getArrDifference(data.gaibian, val)
        for (let n in list) {
          arr.push(data.group[list[n]].label)
        }
        let str_vin = arr.join("--")
        add_car_to_group(data.group_id, str_vin).then((res) => {
          g_vin_list_by_group_id(data.group_id)
        })
      }

    }
    //数组 取出不同的值
    const getArrDifference = (arr1, arr2) => {
      return arr1.concat(arr2).filter(function (v, i, arr) {
        return arr.indexOf(v) === arr.lastIndexOf(v);
      });
    }
    const handleBucketClick = (e) => {
      data.group_id = e.value
      g_vin_list_by_group_id(e.value)

    }

    const g_vin_list_by_group_id = (id) => {
      get_vin_list_by_group_id(id).then((res) => {
        data.group = res.data.data
        data.name = []
        data.gaibian = []
        for (let i = 0; i < res.data.split; i++) {
          data.name.push(i)
          data.gaibian.push(i)
        }
      })
    }
    const closeDialog = () => {
      context.emit("closeDialog");
    }
    //侧边栏展开收缩
    const kai = () => {
      data.isCollapse = !data.isCollapse;
    };
    const routerpath = (path) => {
      router.push({ path: path });
    };
    //显示影藏div
    const show = () => {
      data.display = !data.display;
    };
    //选中车辆  子传父
    // const handleEdit = (row, column, cell, event) => {
    //   data.display = false;
    //   context.emit("clickFu", row);
    // };
    //获取组列表
    const g_car_group_list = () => {
      get_car_group_list(data.leftValue).then((res) => {
        // data.treedata = []
        // data.treedata.push(res.data)
        data.treedata = res.data
      })
    }
    //添加组织
    const addzuzhi = () => {
      add_car_group(data.addvalue, data.par_id).then((res) => {
        g_car_group_list()
        data.add = false
        data.addvalue = ''
      })
    }
    //删除组织
    const delzuzhi = (val) => {
      ElMessageBox.confirm(
        '确定删除组织吗',
        '系统提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
        .then(() => {
          delete_car_group(val.data.value).then((res) => {
            g_car_group_list()
          })
        })
        .catch(() => {
        })
    }
    const upid = (val) => {
      data.upd = true
      data.zuzhiid = val.data.value
      data.upvalue = val.data.label
    }
    //更新组织
    const upzuzhi = () => {
      update_car_group(data.zuzhiid, data.upvalue).then((res) => {
        g_car_group_list()
        data.upd = false
      })
    }
  //  g_car_group_list()
    return {
      handleOpen,
      handleClose,
      kai,
      show,
      addpar,
      upid,
      ...toRefs(data),
      routerpath,
      addzuzhi,
      delzuzhi,
      g_car_group_list,
      handleBucketClick,
      upzuzhi,
      handleChange,
      closeDialog,
      defaultProps,
      filterText,
      treeRef,
      filterNode
    };
  },
};
</script >
<style lang="scss" scoped>
.car_list {
  width: 10%;
  height: 70%;
  margin-top: 5%;
  margin-left: 3.5%;
  position: absolute;
  z-index: 999;
}

.el-menu {
  border: rgb(255, 255, 255);
}

.el-menu-item {
  color: rgb(26, 1, 252);
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}

.zuzhi {
  width: 70%;
  height: 80%;
  position: absolute;
  background-color: rgb(230, 23, 23);
  right: 18%;
  top: 8%;
  z-index: 999;
}

/deep/ .el-transfer-panel {
  width: 250px !important;
  height: 500px !important;
}

/deep/ .el-transfer-panel__body {
  height: 400px !important;
}

/deep/ .el-transfer-panel__list {
  height: 400px !important;
}
</style>